/**
 * Spinner — small rotating arc, currentColor. Used inside Btn loading
 * state and anywhere a request is in flight.
 *
 * The keyframe lives in styles/base.css (@keyframes spin) so we don't
 * inline a <style> tag per instance.
 */
import { CSSProperties } from 'react';

type Props = { size?: number; color?: string; style?: CSSProperties };

export function Spinner({ size = 16, color = 'currentColor', style }: Props) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" style={{ animation: 'spin 1s linear infinite', ...style }}>
      <circle
        cx="12" cy="12" r="9" fill="none" stroke={color}
        strokeWidth="2.5" strokeDasharray="14 30" strokeLinecap="round"
      />
    </svg>
  );
}
